/* =============================================
   SKOCENTRUM UMEÅ – THEME JS v2.0
   ============================================= */

// ── CART ──────────────────────────────────────
const SkoCart = {
  open() {
    document.getElementById('cart-overlay')?.classList.add('open');
    document.getElementById('cart-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  close() {
    document.getElementById('cart-overlay')?.classList.remove('open');
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  },
  async getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  },
  async addItem(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    return res.json();
  },
  async removeItem(key) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    return res.json();
  },
  async render() {
    const cart = await this.getCart();
    const body = document.getElementById('cart-body');
    const foot = document.getElementById('cart-foot');
    const count = document.getElementById('cart-count');
    if (!body) return;
    if (count) count.textContent = cart.item_count;
    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-empty">
        <svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        <p>Din kundkorg är tom</p>
      </div>`;
      if (foot) foot.style.display = 'none';
    } else {
      body.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img src="${item.image}" alt="${item.product_title}">
          <div class="c-info">
            <p class="c-brand">${item.vendor}</p>
            <p class="c-name">${item.product_title}</p>
            <p style="font-size:11px;color:var(--gray)">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
            <p class="c-price">${(item.final_line_price / 100).toLocaleString('sv-SE')} kr</p>
          </div>
          <button class="c-rm" onclick="SkoCart.removeItem('${item.key}').then(()=>SkoCart.render())">×</button>
        </div>
      `).join('');
      if (foot) {
        foot.style.display = 'block';
        const total = document.getElementById('cart-total-price');
        if (total) total.textContent = (cart.total_price / 100).toLocaleString('sv-SE') + ' kr';
      }
    }
  }
};

// ── MOBILE MENU ────────────────────────────────
const MobileMenu = {
  open() {
    document.getElementById('mobile-menu')?.classList.add('open');
    document.getElementById('mobile-menu-overlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  close() {
    document.getElementById('mobile-menu')?.classList.remove('open');
    document.getElementById('mobile-menu-overlay')?.classList.remove('open');
    document.body.style.overflow = '';
    document.querySelector('.mobile-nav')?.classList.remove('drilled');
    document.querySelectorAll('.mobile-nav > li.open').forEach(el => el.classList.remove('open'));
  },
  toggleSubmenu(li) {
    document.querySelectorAll('.mobile-nav > li.open').forEach(el => el.classList.remove('open'));
    li.classList.add('open');
    document.querySelector('.mobile-nav')?.classList.add('drilled');
    document.getElementById('mobile-menu')?.scrollTo({ top: 0 });
  },
  back() {
    document.querySelector('.mobile-nav')?.classList.remove('drilled');
    document.querySelectorAll('.mobile-nav > li.open').forEach(el => el.classList.remove('open'));
  }
};

// ── TOAST ──────────────────────────────────────
function showToast(msg) {
  let t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2800);
}

// ── ACCORDION ──────────────────────────────────
function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      const body = btn.nextElementSibling;
      if (body) body.classList.toggle('open', !expanded);
    });
  });
}

// ── PRODUCT IMAGES ─────────────────────────────
function initProductImages() {
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('.product-main-img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.dataset.full || thumb.src;
    });
  });
}

// ── VARIANT SELECTION ──────────────────────────
function initVariants() {
  const addBtn = document.getElementById('product-add-btn');
  const dataEl = document.getElementById('variant-data');
  const groups = Array.from(document.querySelectorAll('.product-variants'));

  // Produkter utan varianter: lagg-i-korg-knappen anvander id:t fran Liquid
  if (!addBtn) return;
  let selectedVariantId = groups.length ? null : addBtn.dataset.variantId;

  let variants = [];
  if (dataEl) {
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  }

  const selected = new Array(groups.length).fill(null);
  const priceEl = document.getElementById('product-price');
  const summaryEl = document.getElementById('product-option-summary');
  const mainImg = document.getElementById('product-main-img');

  // Las in forvalda varden fran markupen
  groups.forEach(group => {
    const i = Number(group.dataset.optionIndex);
    const active = group.querySelector('.variant-btn.active');
    if (active) selected[i] = active.dataset.value;
  });

  // Matchar ett varde mot ovriga valda alternativ - null i selected raknas som jokertecken
  function matches(variant, index, value) {
    if (variant.options[index] !== value) return false;
    return selected.every((val, i) => i === index || val === null || variant.options[i] === val);
  }

  function currentVariant() {
    if (selected.some(v => v === null)) return null;
    return variants.find(v => selected.every((val, i) => v.options[i] === val)) || null;
  }

  // Grama ut kombinationer som inte finns, stryk over de som ar slutsalda
  function refreshAvailability() {
    groups.forEach(group => {
      const index = Number(group.dataset.optionIndex);
      group.querySelectorAll('.variant-btn').forEach(btn => {
        const value = btn.dataset.value;
        const exists = variants.some(v => matches(v, index, value));
        const inStock = variants.some(v => matches(v, index, value) && v.available);
        btn.classList.toggle('unavailable', !exists);
        btn.classList.toggle('sold-out', exists && !inStock);
        btn.disabled = !exists;
      });
    });
  }

  // Byter huvudbild sa fort ett alternativ valts - kraver inte att alla ar valda.
  // Provar exakt variant forst, slapper sedan ett alternativ i taget bakifran
  // sa att t.ex. enbart fargvalet racker for att byta bild.
  function updateImage(exact) {
    if (!mainImg) return;

    let src = exact && exact.image ? exact.image : null;

    // Slapp ett alternativ i taget bakifran tills nagon variant med bild matchar
    for (let depth = selected.length; depth > 0 && !src; depth--) {
      const match = variants.find(v =>
        v.image && selected.slice(0, depth).every((val, i) => val === null || v.options[i] === val)
      );
      if (match) src = match.image;
    }

    if (!src) return;

    mainImg.src = src;
    document.querySelectorAll('.product-thumb').forEach(t => {
      t.classList.toggle('active', t.dataset.full === src);
    });
  }

  function refreshUI() {
    const variant = currentVariant();
    selectedVariantId = variant ? String(variant.id) : null;

    if (summaryEl) {
      summaryEl.textContent = groups
        .map((g, i) => selected[i] ? g.dataset.optionName + ': ' + selected[i] : null)
        .filter(Boolean)
        .join(' \u00b7 ');
    }

    if (variant && priceEl) {
      priceEl.innerHTML = variant.compare_at_price
        ? '<span class="product-price-was">' + variant.compare_at_price + '</span>' +
          '<span class="product-price-sale">' + variant.price + '</span>'
        : variant.price;
    }

    updateImage(variant);

    if (variant) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Lägg i kundkorg' : 'Slutsåld';
      addBtn.dataset.variantId = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    } else {
      addBtn.disabled = false;
      addBtn.textContent = 'Lägg i kundkorg';
    }
  }

  // Ett aktivt val PER optionsgrupp - buggen tidigare var att alla knappar nollstalldes
  groups.forEach(group => {
    const index = Number(group.dataset.optionIndex);
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        selected[index] = btn.dataset.value;
        refreshAvailability();
        refreshUI();
      });
    });
  });

  if (groups.length) {
    refreshAvailability();
    refreshUI();
  }

  addBtn.addEventListener('click', async () => {
    if (!selectedVariantId) {
      const missing = groups.find((g, i) => selected[i] === null);
      if (missing) {
        missing.style.setProperty('outline', '2px solid #c0392b');
        setTimeout(() => missing.style.removeProperty('outline'), 1500);
        showToast('Välj ' + missing.dataset.optionName.toLowerCase() + ' först');
      }
      return;
    }
    addBtn.textContent = 'Lägger i korg…';
    addBtn.disabled = true;
    try {
      await SkoCart.addItem(selectedVariantId);
      await SkoCart.render();
      SkoCart.open();
      showToast('Lagt i kundkorgen ✓');
    } catch(e) {
      showToast('Något gick fel, försök igen');
    } finally {
      addBtn.textContent = 'Lägg i kundkorg';
      addBtn.disabled = false;
    }
  });
}

// ── SEARCH ─────────────────────────────────────
function initSearch() {
  document.querySelectorAll('.nav-search input, .mobile-search').forEach(input => {
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}`;
      }
    });
  });
}

// ── QUICK ADD (product cards) ──────────────────
function initQuickAdd() {
  const modal   = document.getElementById('qa-modal');
  const overlay = document.getElementById('qa-overlay');
  const optsEl  = document.getElementById('qa-options');
  const addEl   = document.getElementById('qa-add');
  const imgEl   = document.getElementById('qa-image');
  const titleEl = document.getElementById('qa-title');
  const priceEl = document.getElementById('qa-price');
  const linkEl  = document.getElementById('qa-link');

  let data = null;
  let selected = [];

  function close() {
    modal?.classList.remove('open');
    overlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  function matches(variant, index, value) {
    if (variant.options[index] !== value) return false;
    return selected.every((val, i) => i === index || val === null || variant.options[i] === val);
  }

  function currentVariant() {
    if (!data || selected.some(v => v === null)) return null;
    return data.variants.find(v => selected.every((val, i) => v.options[i] === val)) || null;
  }

  // Etikett for lagerstatus - exakt antal bara om butiken valt det
  function stockLabel(variant) {
    if (!variant || !variant.available) return 'Slut i lager';
    if (variant.qty === null || variant.qty === undefined) return 'I lager';
    if (window.SKO_STOCK_EXACT) return variant.qty + ' i lager';
    return variant.qty <= 2 ? 'Få kvar' : 'I lager';
  }

  function render() {
    optsEl.innerHTML = '';
    data.options.forEach((option, index) => {
      const group = document.createElement('div');
      group.className = 'qa-group';
      const label = document.createElement('p');
      label.className = 'qa-label';
      label.textContent = option.name;
      group.appendChild(label);

      const row = document.createElement('div');
      row.className = 'qa-row';
      option.values.forEach(value => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qa-chip';
        btn.textContent = value;

        const exists  = data.variants.some(v => matches(v, index, value));
        const inStock = data.variants.some(v => matches(v, index, value) && v.available);
        if (!exists) { btn.classList.add('unavailable'); btn.disabled = true; }
        else if (!inStock) btn.classList.add('sold-out');
        if (selected[index] === value) btn.classList.add('active');

        btn.addEventListener('click', () => {
          selected[index] = value;
          render();
        });
        row.appendChild(btn);
      });
      group.appendChild(row);
      optsEl.appendChild(group);
    });

    const variant = currentVariant();
    if (variant) {
      priceEl.textContent = variant.price + ' · ' + stockLabel(variant);
      addEl.disabled = !variant.available;
      addEl.textContent = variant.available ? 'Lägg i kundkorg' : 'Slutsåld';
    } else {
      const missing = data.options.find((o, i) => selected[i] === null);
      priceEl.textContent = data.variants[0] ? data.variants[0].price : '';
      addEl.disabled = false;
      addEl.textContent = missing ? 'Välj ' + missing.name.toLowerCase() : 'Lägg i kundkorg';
    }
  }

  function open(json, card) {
    data = json;
    selected = new Array(data.options.length).fill(null);

    // Ar bara ett varde mojligt i en grupp - forvalj det
    data.options.forEach((option, i) => {
      if (option.values.length === 1) selected[i] = option.values[0];
    });

    titleEl.textContent = data.title;
    linkEl.href = data.url;
    if (data.image) { imgEl.src = data.image; imgEl.alt = data.title; imgEl.style.display = ''; }
    else imgEl.style.display = 'none';

    render();
    modal.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  addEl?.addEventListener('click', async () => {
    const variant = currentVariant();
    if (!variant) {
      const index = data.options.findIndex((o, i) => selected[i] === null);
      optsEl.querySelectorAll('.qa-group')[index]?.classList.add('shake');
      setTimeout(() => optsEl.querySelectorAll('.qa-group')[index]?.classList.remove('shake'), 600);
      return;
    }
    addEl.textContent = 'Lägger i korg…';
    addEl.disabled = true;
    try {
      await SkoCart.addItem(variant.id);
      await SkoCart.render();
      close();
      SkoCart.open();
      showToast('Lagt i kundkorgen ✓');
    } catch(e) {
      showToast('Något gick fel, försök igen');
    } finally {
      addEl.textContent = 'Lägg i kundkorg';
      addEl.disabled = false;
    }
  });

  document.getElementById('qa-close')?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.preventDefault();
      e.stopPropagation();

      // Produkt med flera varianter - oppna valjaren istallet for att gissa storlek
      const pickerId = btn.dataset.picker;
      if (pickerId) {
        const el = document.getElementById(pickerId);
        if (el) {
          try { open(JSON.parse(el.textContent), btn.closest('.prod-card')); return; }
          catch (err) { /* faller igenom till produktsidan */ }
        }
        window.location.href = btn.closest('a')?.href || '#';
        return;
      }

      const variantId = btn.dataset.variantId;
      if (!variantId) { window.location.href = btn.closest('a')?.href || '#'; return; }
      btn.textContent = '…';
      btn.disabled = true;
      try {
        await SkoCart.addItem(variantId);
        await SkoCart.render();
        SkoCart.open();
        showToast('Lagt i kundkorgen ✓');
      } catch(e) {
        showToast('Gå till produktsidan för att välja storlek');
      } finally {
        btn.textContent = 'Lägg i kundkorg';
        btn.disabled = false;
      }
    });
  });
}

// ── INIT ───────────────────────────────────────

// ── Promostrip: vaxlar mellan budskapen pa mobil ──
function initPromoRotator() {
  const strip = document.querySelector('.promo-strip');
  if (!strip) return;
  const items = Array.from(strip.querySelectorAll('.promo-item'));
  if (items.length < 2) return;

  const mq = window.matchMedia('(max-width: 768px)');
  let index = 0;
  let timer = null;

  function show(i) {
    items.forEach((el, n) => el.classList.toggle('is-active', n === i));
  }

  function start() {
    show(0);
    index = 0;
    clearInterval(timer);
    timer = setInterval(() => {
      index = (index + 1) % items.length;
      show(index);
    }, 3200);
  }

  function stop() {
    clearInterval(timer);
    timer = null;
    items.forEach(el => el.classList.remove('is-active'));
  }

  function sync() {
    if (mq.matches) start(); else stop();
  }

  sync();
  mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
}

document.addEventListener('DOMContentLoaded', () => {

  // Cart
  document.getElementById('cart-toggle')?.addEventListener('click', () => {
    SkoCart.render().then(() => SkoCart.open());
  });
  document.getElementById('cart-overlay')?.addEventListener('click', SkoCart.close.bind(SkoCart));
  document.querySelector('.cart-close')?.addEventListener('click', SkoCart.close.bind(SkoCart));
  document.querySelector('.checkout-btn')?.addEventListener('click', () => { window.location.href = '/checkout'; });

  // Mobile menu
  document.getElementById('hamburger-btn')?.addEventListener('click', () => {
    const menu = document.getElementById('mobile-menu');
    const btn = document.getElementById('hamburger-btn');
    const isOpen = menu && menu.classList.contains('open');
    if (isOpen) { MobileMenu.close(); btn?.classList.remove('open'); }
    else { MobileMenu.open(); btn?.classList.add('open'); }
  });

  // Stang menyn nar man klickar pa en lank
  document.querySelectorAll('.mobile-nav a, .mobile-menu-footer a').forEach(a => {
    a.addEventListener('click', () => {
      // Foraldralankar fäller ut undermenyn i stället for att stanga menyn
      const li = a.parentElement;
      if (li && li.matches('.mobile-nav > li') && li.querySelector('.mobile-submenu')) return;
      MobileMenu.close();
      document.getElementById('hamburger-btn')?.classList.remove('open');
    });
  });
  document.getElementById('mobile-menu-overlay')?.addEventListener('click', () => {
    MobileMenu.close();
    document.getElementById('hamburger-btn')?.classList.remove('open');
  });
  document.getElementById('mobile-menu-close')?.addEventListener('click', MobileMenu.close.bind(MobileMenu));
  document.querySelectorAll('.mobile-back').forEach(b => {
    b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); MobileMenu.back(); });
  });
  document.querySelectorAll('.mobile-nav > li > a').forEach(a => {
    const li = a.parentElement;
    if (li.querySelector('.mobile-submenu')) {
      a.addEventListener('click', e => { e.preventDefault(); MobileMenu.toggleSubmenu(li); });
    }
  });

  initPromoRotator();
  initSearch();
  initAccordions();
  initProductImages();
  initVariants();
  initQuickAdd();

  SkoCart.getCart().then(cart => {
    const count = document.getElementById('cart-count');
    if (count) count.textContent = cart.item_count;
  });
});
